import { styled } from "../../../../styles";

export const ErrorsContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "8px",

  width: 403,
  marginTop: "8px",
  padding: "16px",

  borderRadius: "12px",
  border: "1px solid $error-lighter",
  backgroundColor: "$error-lightest",
});

export const ErrorsTitle = styled("p", {
  color: "$error-dark",
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "20px",
});

export const ErrorsList = styled("ul", {
  display: "flex",
  flexDirection: "column",
  gap: "4px",

  margin: 0,
  paddingLeft: "18px",
});

export const ErrorItem = styled("li", {
  color: "$charcoal",
  fontFamily: "$openSans",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "20px",
});
